import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/od_ss_avatar.png';
import _imports_1 from '../assets/ss_tel.png';
const _withScopeId = n => (_pushScopeId("data-v-45f565d8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = {
  style: {
    "text-align": "center",
    "padding-bottom": "10px",
    "background": "#fff"
  }
};
const _hoisted_4 = ["src"];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-weight": "bold",
    "font-size": "18px"
  }
}, "预约成功", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_7 = {
  style: {
    "color": "#646566"
  }
};
const _hoisted_8 = {
  key: 4,
  class: "flex-c"
};
const _hoisted_9 = {
  key: 0,
  class: "border_top_wrap"
};
const _hoisted_10 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-size": "14px"
  }
}, " 后自动确认完成", -1));
const _hoisted_12 = {
  key: 1,
  class: "border_top_wrap"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_14 = {
  key: 1
};
const _hoisted_15 = {
  class: "soilder_wrap"
};
const _hoisted_16 = {
  class: "list flex-c-b ide_wrap"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ide_l flex-c-c"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "ide_avatar"
})], -1));
const _hoisted_18 = {
  class: "ide_r pl-20"
};
const _hoisted_19 = {
  class: "flex-c name_wrap"
};
const _hoisted_20 = {
  class: "flex-c mt-20 phone_wrap"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "ide_icon3"
}, null, -1));
const _hoisted_22 = ["href"];
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ide_cont mt-20"
}, [/*#__PURE__*/_createTextVNode(" 该服务人员已通过全季到家技能与实名认证考核，如上门人员与接单人员信息不符，请拨打客服热线 "), /*#__PURE__*/_createElementVNode("strong", {
  class: "call_p"
}, [/*#__PURE__*/_createElementVNode("a", {
  href: "tel:40066-31115",
  class: "phone_text"
}, "40066-31115")]), /*#__PURE__*/_createTextVNode(" 进行确认。 ")], -1));
const _hoisted_24 = {
  key: 2,
  class: "cuslink flex-col"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cuslink_tit"
}, "专属客服", -1));
const _hoisted_26 = {
  class: "cuslink_cont"
};
const _hoisted_27 = ["href"];
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "80px"
  }
}, null, -1));
const _hoisted_29 = {
  class: "footerBtn"
};
const _hoisted_30 = {
  key: 2,
  class: "reschedule"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "订单保权延期中...", -1));
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "detail"
}, [/*#__PURE__*/_createElementVNode("div", null, "您是否需要暂停此次服务, 延后使用?"), /*#__PURE__*/_createElementVNode("span", {
  class: "serviceNo"
}, "服务热线：40066-31115")], -1));
import { ref, onMounted, getCurrentInstance } from "vue";
import { useRouter, useRoute } from "vue-router";
import commonMethod from '../common/common';
import { Dialog } from 'vant';
export default /*#__PURE__*/_defineComponent({
  __name: 'reserved',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    const route = useRoute();
    const VanDialog = Dialog.Component;
    const bgImg = ref(require('../assets/order.png'));
    const orderDetail = ref({}); // 订单详情
    const is_delay = ref(false); // 是否延期
    const area_selected = ref('');
    const timeSelected = ref('');
    const resStatus = ref('');
    const rSmall = ref('');
    const showReservedBtn = ref(false);
    const isMore = ref(false);
    const isjiadian = ref(false);
    const isHood = ref(false);
    const brand_name = ref('');
    const h_type = ref('');
    const soldier = ref([]);
    onMounted(() => {
      proxy.$api.post(`${proxy.$url}Index/get_soi`, {
        su: route.params.su
      }).then(res => {
        if (res.status == 1) {
          orderDetail.value = res.orderDetail;
          if (res.orderDetail.rs_appid.indexOf("zhycfh") != -1) {
            bgImg.value = require('../assets/zh1.jpg');
          }
          is_delay.value = orderDetail.value.is_delay == 0 ? false : true;
          // 判断是否是家电
          if (orderDetail.value.st_id == 1) {
            isjiadian.value = true;
            brand_name.value = orderDetail.value.brand_name ? orderDetail.value.brand_name : '未选择家电品牌';
            // 等于10和11的时候，说明是油烟机
            isHood.value = orderDetail.value.s_id == 10 || orderDetail.value.s_id == 11 || orderDetail.value.s_id == 20 ? true : false;
            if (isHood.value) {
              h_type.value = orderDetail.value.h_type == 1 ? '侧吸' : orderDetail.value.h_type == 2 ? '直吸' : '未选择油烟机类型';
            }
          }
          // 地址赋值
          area_selected.value = orderDetail.value.province == null || orderDetail.value.city == null || orderDetail.value.district == null ? '服务地址已变更' : orderDetail.value.province + '/' + orderDetail.value.city + '/' + orderDetail.value.district;
          // 时间显示赋值
          timeSelected.value = orderDetail.value.res_time;
          switch (orderDetail.value.res_status) {
            case '1':
              // 判断是否在48小时之内
              dealTime();
              resStatus.value = '预约成功';
              rSmall.value = '注：客服人员会在稍后与您联系确认订单';
              showReservedBtn.value = true;
              break;
            case '3':
              //已接单，已派单
              // 订单soo_status=2是已核销,finish_status=1说明自个已完成
              if (orderDetail.value.soo_status == 2 || orderDetail.value.finish_status == 1 || orderDetail.value.is_kf_opt == 1) {
                showReservedBtn.value = false;
                resStatus.value = '服务已完成';
              } else if (orderDetail.value.soo_status == 1 && orderDetail.value.finish_status == 0 && orderDetail.value.oc_id && orderDetail.value.oc_id != null && orderDetail.value.oc_id != 0) {
                //已派单，未完成
                dealTime();
                showReservedBtn.value = true;
                resStatus.value = '等待上门服务';
              } else {
                showReservedBtn.value = true;
                resStatus.value = '等待上门服务';
              }
              break;
            case '4':
              resStatus.value = '预约已取消';
              break;
            default:
              break;
          }
          if (orderDetail.value.rs_appid == 'zhycfh') {
            showReservedBtn.value = false;
          }
          // 判断是否有服务兵
          if (JSON.stringify(res.soldier) != '[]') {
            isMore.value = true;
            soldier.value = res.soldier;
            if (soldier.value.phone) {
              let reg = /^(.{3}).*(.{4})$/;
              soldier.value.real_phone = soldier.value.phone;
              soldier.value.phone = soldier.value.phone.replace(reg, '$1****$2');
            }
          }
          // 查找专属客服
          getKfLink();
        } else {
          commonMethod.dialog('预约信息加载异常', '抱歉通知您，您的订单处于取消状态或由于系统繁忙，数据加载异常,请退出重试,感谢您的配合!', 1);
        }
      }).catch(err => {
        commonMethod.dialog('预约信息加载异常', '抱歉通知您由于系统繁忙您的数据加载异常,请退出重试,感谢您的配合!', 1);
      });
    });
    // 显示时间判断，防止结束时间小于开始时间
    const judgeTime = (start_time, end_time) => {
      let arr = start_time.split(':');
      // 如果开始时间大于结束时间，就直接显示开始时间，不显示结束时间
      if (new Date(start_time).getTime() > new Date(end_time).getTime()) {
        timeSelected.value = arr[0] + ':' + arr[1];
      } else {
        let arr1 = end_time.split(' ');
        let arr2 = arr1[1].split(':');
        timeSelected.value = arr[0] + ':' + arr[1] + '-' + arr2[0] + ':' + arr2[1];
      }
    };
    // 48小时时间判断
    const diffHours = ref('');
    const showServe = ref(false);
    const showCountdown = ref(false);
    const countdown = ref('');
    const countDown = ref(null);
    const dealTime = () => {
      diffHours.value = (orderDetail.value.res_timestamp - orderDetail.value.now_timestamp) / 3600;
      // 如果到预约时间再显示完成按钮
      if (diffHours.value <= 0) {
        showServe.value = true;
        // 判断客服是否已经点击完成，如果已经点击就显示自动确认倒计时;
        if (orderDetail.value.kf_finish_time > 0) {
          showCountdown.value = true;
          countdown.value = orderDetail.value.kf_finish_expire * 1000 - new Date().getTime();
          // 延迟执行，不然找不到start方法
          setTimeout(() => {
            countDown.value.start();
          }, 800);
        }
      }
    };
    // 倒计时结束事件
    const finish = () => {
      proxy.$api.post(`${proxy.$url}Evaluate/completeOrder`, {
        vender_order_no: orderDetail.value.vender_order_no,
        oc_id: orderDetail.value.oc_id
      }).then(res => {
        if (res.status) {
          commonMethod.notify('success', '确认完成');
          setTimeout(() => {
            location.reload();
          }, 1000);
        }
      }).catch(err => {
        commonMethod.notify('warning', '网络异常，请稍后重试');
      });
    };
    // 专属客服链接
    const isBind = ref('');
    const kfLink = ref('');
    const getKfLink = () => {
      proxy.$api.post(`${proxy.$wxurl}H5/Kefu/showKefu`, {
        vender_order_no: orderDetail.value.vender_order_no
      }).then(res => {
        if (res.status == 1) {
          isBind.value = res.data.bind_kefu;
          kfLink.value = res.data.kf_url;
          if (res.data.kf_url) {
            isMore.value = true;
          }
        }
      });
    };
    // 绑定专属客服链接
    const bindKfLink = () => {
      if (isBind.value) {
        return;
      }
      proxy.$api.post(`${proxy.$wxurl}H5/Kefu/bindKefu`, {
        vender_order_no: orderDetail.value.vender_order_no
      });
    };
    // 保权延期
    const showDialog = ref(false);
    const setTime = ref(null);
    const dialogText = ref('请仔细阅读提示, 5 秒后可确认');
    const showDialogBtn = ref(true);
    const showConfirm = ref(false);
    const showCancel = ref(false);
    const keepQY = () => {
      if (diffHours.value > 0 && diffHours.value < 48) {
        commonMethod.dialog('保权延期操作提醒', '您的预约时间临近48小时，如需保权延期，请拨打');
        return;
      } else if (diffHours.value < 0) {
        commonMethod.dialog('保权延期操作提醒', '您的订单已经过期，无法保权延期！');
        return;
      }
      // 设置倒计时秒数
      let time = 5;
      // 打开弹窗
      showDialog.value = true;
      // 定义定时器
      setTime.value = setInterval(() => {
        time -= 1;
        dialogText.value = '请仔细阅读提示, ' + time + ' 秒后可确认';
        if (time == 0) {
          // 关闭按钮提示
          showDialogBtn.value = false;
          // 显示成功和取消按钮
          showConfirm.value = showCancel.value = true;
          // 清空定时器
          clearInterval(setTime.value);
        }
      }, 1000);
    };
    // 保权延期弹窗关闭
    const dialogClose = () => {
      clearInterval(setTime.value);
      setTimeout(() => {
        dialogText.value = '请仔细阅读提示, 5 秒后可确认';
        showDialogBtn.value = true;
        showConfirm.value = showCancel.value = false;
      }, 500);
    };
    // 保权延期弹窗确认
    const dialogConfirm = () => {
      proxy.$api.post(`${proxy.$url}Delay/applayDelay`, {
        vender_order_no: orderDetail.value.vender_order_no
      }).then(() => {
        commonMethod.notify('success', '保权延期成功');
        setTimeout(() => {
          location.reload();
        }, 1000);
      });
    };
    const router = useRouter();
    // 重新预约
    const reschedule = () => {
      if (orderDetail.value.rs_appid == 'zhycfh') {
        router.push({
          path: '/zh/' + route.params.su,
          query: {
            type: 'repeat'
          }
        });
      } else {
        router.push({
          path: '/u/' + route.params.su,
          query: {
            type: 'repeat'
          }
        });
      }
    };
    // 去完成服务
    const goServe = () => {
      Dialog.confirm({
        title: '完成服务提醒',
        message: '您的服务订单是否已上门完成服务?<br><span style="line-height: 30px;padding: 5px 20px;font-size: 12px;border: 1px solid #b50029;color: #b50029;border-radius: 5px !important;background: #fff;">服务热线：<a style="color: #b50029;" href="tel:40066-31115"> 40066-31115 </a></span>',
        allowHtml: true
      }).then(() => {
        router.push({
          name: 'serve',
          state: {
            order_no: orderDetail.value.vender_order_no,
            st_id: orderDetail.value.st_id
          }
        });
      }).catch(() => {});
    };
    // 拨打电话
    const callCS = () => {
      window.location.href = 'tel:4006631115';
    };
    // 返回上一页
    const back = () => {
      window.history.go(-1);
    };
    return (_ctx, _cache) => {
      const _component_van_nav_bar = _resolveComponent("van-nav-bar");
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_count_down = _resolveComponent("van-count-down");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_icon = _resolveComponent("van-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [orderDetail.value.is_hide_nav == 0 ? (_openBlock(), _createBlock(_component_van_nav_bar, {
        key: 0,
        title: "服务订单",
        "left-arrow": "",
        border: "",
        fixed: "",
        placeholder: "",
        onClickLeft: back
      })) : _createCommentVNode("", true), !is_delay.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
        style: {
          "display": "block",
          "margin": "0 auto"
        },
        width: "80%",
        src: bgImg.value
      }, null, 8, _hoisted_4), _hoisted_5, _hoisted_6, _createElementVNode("span", _hoisted_7, "订单状态为" + _toDisplayString(resStatus.value), 1)]), _createElementVNode("div", null, [_createVNode(_component_van_field, {
        label: "服务类型",
        modelValue: orderDetail.value.s_name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => orderDetail.value.s_name = $event),
        "error-message": orderDetail.value.vender_order_no,
        readonly: ""
      }, null, 8, ["modelValue", "error-message"]), isjiadian.value && !isMore.value ? (_openBlock(), _createBlock(_component_van_field, {
        key: 0,
        label: "家电品牌",
        modelValue: brand_name.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => brand_name.value = $event),
        readonly: ""
      }, null, 8, ["modelValue"])) : _createCommentVNode("", true), isHood.value && !isMore.value ? (_openBlock(), _createBlock(_component_van_field, {
        key: 1,
        label: "家电类型",
        modelValue: h_type.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => h_type.value = $event),
        readonly: ""
      }, null, 8, ["modelValue"])) : _createCommentVNode("", true), _createVNode(_component_van_field, {
        label: "期望上门时间",
        modelValue: timeSelected.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => timeSelected.value = $event),
        readonly: ""
      }, null, 8, ["modelValue"]), !isMore.value ? (_openBlock(), _createBlock(_component_van_field, {
        key: 2,
        label: "上门地址",
        modelValue: area_selected.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => area_selected.value = $event),
        "error-message": orderDetail.value.c_address,
        readonly: ""
      }, null, 8, ["modelValue", "error-message"])) : _createCommentVNode("", true), orderDetail.value.st_id == 3 && !isMore.value ? (_openBlock(), _createBlock(_component_van_field, {
        key: 3,
        label: "户型类别",
        modelValue: orderDetail.value.house_type,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => orderDetail.value.house_type = $event),
        readonly: ""
      }, null, 8, ["modelValue"])) : _createCommentVNode("", true), orderDetail.value.st_id == 3 && !isMore.value && orderDetail.value.rs_appid.indexOf('zhycfh') != -1 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_van_field, {
        label: "建筑面积",
        modelValue: orderDetail.value.build_area,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => orderDetail.value.build_area = $event),
        readonly: ""
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        label: "赠送/自建面积",
        modelValue: orderDetail.value.free_area,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => orderDetail.value.free_area = $event),
        "label-width": 90,
        readonly: ""
      }, null, 8, ["modelValue"])])) : _createCommentVNode("", true), !isMore.value ? (_openBlock(), _createBlock(_component_van_field, {
        key: 5,
        label: "联系方式",
        modelValue: orderDetail.value.c_name,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => orderDetail.value.c_name = $event),
        "error-message": orderDetail.value.c_phone,
        readonly: ""
      }, null, 8, ["modelValue", "error-message"])) : _createCommentVNode("", true), _createVNode(_component_van_field, {
        label: "订单状态",
        modelValue: resStatus.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => resStatus.value = $event),
        "error-message": rSmall.value,
        readonly: ""
      }, null, 8, ["modelValue", "error-message"]), orderDetail.value.account_manager_selected && !isMore.value ? (_openBlock(), _createBlock(_component_van_field, {
        key: 6,
        label: "客户经理",
        modelValue: orderDetail.value.account_manager_selected,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => orderDetail.value.account_manager_selected = $event),
        readonly: ""
      }, null, 8, ["modelValue"])) : _createCommentVNode("", true), _createElementVNode("div", null, [showServe.value ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", {
        class: "btn border_top",
        style: _normalizeStyle([{
          "flex-direction": "column",
          "align-items": "flex-end"
        }, {
          'justify-content': showCountdown.value ? 'space-between' : 'flex-end'
        }])
      }, [_withDirectives(_createElementVNode("div", _hoisted_10, [_createVNode(_component_van_count_down, {
        ref_key: "countDown",
        ref: countDown,
        time: countdown.value,
        format: "DD 天 HH 时 mm 分 ss 秒",
        "auto-start": false,
        onFinish: finish
      }, null, 8, ["time"]), _hoisted_11], 512), [[_vShow, showCountdown.value]]), _createVNode(_component_van_button, {
        plain: "",
        color: "#b50029",
        onClick: goServe
      }, {
        default: _withCtx(() => [_createTextVNode("已上门完成服务确认")]),
        _: 1
      })], 4)])) : (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", {
        class: "btn border_top",
        style: _normalizeStyle({
          'justify-content': showReservedBtn.value ? 'space-between' : 'flex-end'
        })
      }, [showReservedBtn.value ? (_openBlock(), _createBlock(_component_van_button, {
        key: 0,
        style: {
          "padding": "0 5px"
        },
        plain: "",
        type: "warning",
        onClick: keepQY
      }, {
        default: _withCtx(() => [_createTextVNode(" 若需保留权益 "), _hoisted_13, _createTextVNode(" 请点击延期 ")]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_van_button, {
        plain: "",
        color: "#b50029",
        onClick: callCS
      }, {
        default: _withCtx(() => [_createTextVNode("服务热线：40066-31115")]),
        _: 1
      })], 4)]))])]), soldier.value.name || kfLink.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "more_wrap2 flex-c-c",
        onClick: _cache[11] || (_cache[11] = $event => isMore.value = !isMore.value)
      }, [_createElementVNode("span", null, _toDisplayString(isMore.value ? '更多' : '收起'), 1), _createVNode(_component_van_icon, {
        name: isMore.value ? 'arrow-down' : 'arrow-up',
        color: "#999"
      }, null, 8, ["name"])])) : _createCommentVNode("", true), soldier.value.name ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("span", null, _toDisplayString(soldier.value.name), 1)]), _createElementVNode("div", _hoisted_20, [_hoisted_21, _createTextVNode(" " + _toDisplayString(soldier.value.phone) + " ", 1), _createElementVNode("a", {
        href: 'tel:' + soldier.value.real_phone + '',
        class: "phone_text phone_text1"
      }, "拨打", 8, _hoisted_22)]), _hoisted_23])])])])) : _createCommentVNode("", true), kfLink.value && orderDetail.value.rs_appid != 'rongdata' ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_hoisted_25, _createElementVNode("span", _hoisted_26, [_createTextVNode(" 专属服务管家（客服）为您提供更便捷的服务体验，请 "), _createElementVNode("a", {
        href: kfLink.value,
        class: "custom_link",
        onClick: bindKfLink
      }, "点击这里", 8, _hoisted_27)])])) : _createCommentVNode("", true), _hoisted_28, _createElementVNode("div", _hoisted_29, [_createVNode(_component_van_button, {
        round: "",
        block: "",
        color: "#b50029",
        onClick: callCS
      }, {
        default: _withCtx(() => [_createTextVNode("呼叫客服")]),
        _: 1
      })])])) : (_openBlock(), _createElementBlock("div", _hoisted_30, [_hoisted_31, _createVNode(_component_van_button, {
        round: "",
        block: "",
        color: "#b50029",
        onClick: reschedule
      }, {
        default: _withCtx(() => [_createTextVNode("重新预约")]),
        _: 1
      })])), _createVNode(_unref(VanDialog), {
        class: "dialog",
        show: showDialog.value,
        "onUpdate:show": _cache[12] || (_cache[12] = $event => showDialog.value = $event),
        title: "保权延期确认信息",
        "close-on-click-overlay": "",
        onConfirm: dialogConfirm,
        onClose: dialogClose,
        "show-cancel-button": showCancel.value,
        "show-confirm-button": showConfirm.value
      }, {
        default: _withCtx(() => [_hoisted_32, _withDirectives(_createVNode(_component_van_button, {
          style: {
            "margin-bottom": "10px"
          },
          round: "",
          type: "warning"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(dialogText.value), 1)]),
          _: 1
        }, 512), [[_vShow, showDialogBtn.value]])]),
        _: 1
      }, 8, ["show", "show-cancel-button", "show-confirm-button"])]);
    };
  }
});